const darkTheme = {
	themeName: 'SRS Dark Theme',
	palette: {
		type: 'dark',
		primary: { main: '#79C2E2' },
		secondary: { main: '#00B193' },
		highlight: { main: '#F3901D' },
		topper: {
			main: 'black',
			contrastText: 'white'
		},
		error: { main: '#EE3424' },
		success: { main: '#20d420' },
		action: {
			selected: 'rgba(0, 0, 0, 0.34)',
			hover: 'rgba(0, 0, 0, 0.28)'
		}
	},
	typography: {
		useNextVariants: true
	}
};

const lightTheme = {
	themeName: 'SRS Light Theme',
	palette: {
		background: {
			default: '#fafafa'
		},
		primary: { main: '#005288' },
		success: { main: '#20d420' },
		secondary: { main: '#00B193' },
		highlight: { main: '#F3901D' },
		topper: { main: '#005288' }
	},
	typography: {
		useNextVariants: true
	}
};

export { darkTheme };
export { lightTheme };
